import { render, staticRenderFns } from "./inviteReg.vue?vue&type=template&id=03bb0ee2&"
import script from "./inviteReg.vue?vue&type=script&lang=js&"
export * from "./inviteReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports